/**
 * gfg-script.js
 * Sticky header + predictive search (desktop e mobile)
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────
     STICKY HEADER
  ───────────────────────────────────────────────────────── */
  const headerEl = document.getElementById('gfg-header-component');
  if (!headerEl) return;

  const sticky = headerEl.dataset.sticky;

  if (sticky === 'always') {
    headerEl.classList.add('gfg-header--sticky');
  }

  if (sticky === 'scroll-up') {
    headerEl.classList.add('gfg-header--sticky');
    let lastY = window.scrollY;
    headerEl.style.transition = 'transform 0.3s ease';

    window.addEventListener('scroll', () => {
      const currentY = window.scrollY;
      const isAtTop = currentY <= headerEl.offsetHeight;
      headerEl.style.transform = (currentY < lastY || isAtTop) ? 'translateY(0)' : 'translateY(-100%)';
      lastY = currentY;
    }, { passive: true });
  }

  /* ─────────────────────────────────────────────────────────
     PREDICTIVE SEARCH — funzione riutilizzabile
     Usata sia per l'input desktop che per quello mobile.
  ───────────────────────────────────────────────────────── */

  /**
   * Genera l'HTML dei risultati predittivi
   * @param {string} query
   * @returns {string} HTML
   */
  async function fetchPredictiveHTML(query) {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=5&resources[options][fields]=title,product_type,variants.title`;
    const resp = await fetch(url);
    if (!resp.ok) return '';

    const data = await resp.json();
    const products = data.resources?.results?.products || [];
    const collections = data.resources?.results?.collections || [];

    let html = '';

    if (collections.length > 0) {
      html += '<div class="gfg-search-results__group">';
      html += '<p class="gfg-search-results__heading">Collezioni</p><ul>';
      collections.forEach((c) => {
        html += `<li><a class="gfg-search-results__item" href="${c.url}">${c.title}</a></li>`;
      });
      html += '</ul></div>';
    }

    if (products.length > 0) {
      html += '<div class="gfg-search-results__group">';
      html += '<p class="gfg-search-results__heading">Prodotti</p><ul>';
      products.forEach((p) => {
        const img = p.image
          ? `<img src="${p.image}" alt="${p.title}" class="gfg-search-results__thumb" loading="lazy" width="48" height="48">`
          : '';
        html += `<li><a class="gfg-search-results__item gfg-search-results__item--product" href="${p.url}">${img}<span>${p.title}</span></a></li>`;
      });
      html += '</ul></div>';
    }

    if (html === '') {
      html = `<p class="gfg-search-results__empty">Nessun risultato per "<strong>${query}</strong>"</p>`;
    }

    html += `<div class="gfg-search-results__footer"><a href="/search?q=${encodeURIComponent(query)}" class="gfg-search-results__view-all">Vedi tutti i risultati →</a></div>`;
    return html;
  }

  /**
   * Inizializza la predictive search su un input/results pair
   * @param {HTMLInputElement} input
   * @param {HTMLElement} results
   * @param {HTMLFormElement} form
   * @param {Element} closeOutsideTarget - elemento contenitore per "click fuori"
   */
  function initPredictiveSearch(input, results, form, closeOutsideTarget) {
    if (!input || !results || !form) return;

    let timer = null;

    function open() { results.classList.add('is-open'); }
    function close() { results.classList.remove('is-open'); }

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; close(); return; }

      timer = setTimeout(async () => {
        try {
          results.innerHTML = await fetchPredictiveHTML(q);
          open();
        } catch (e) {
          console.warn('[gfg-search] Error:', e);
        }
      }, 250);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) open();
    });

    form.addEventListener('submit', (e) => {
      if (!input.value.trim()) e.preventDefault();
    });

    document.addEventListener('click', (e) => {
      if (closeOutsideTarget && !closeOutsideTarget.contains(e.target)) close();
    });
  }

  /* ─────────────────────────────────────────────────────────
     INIZIALIZZA — Desktop
  ───────────────────────────────────────────────────────── */
  initPredictiveSearch(
    document.getElementById('gfg-search-input'),
    document.getElementById('gfg-search-results'),
    document.getElementById('gfg-search-form'),
    document.querySelector('.gfg-search-inline')
  );

  /* ─────────────────────────────────────────────────────────
     INIZIALIZZA — Mobile (stessa logica, input diverso)
  ───────────────────────────────────────────────────────── */
  initPredictiveSearch(
    document.getElementById('gfg-search-input-mobile'),
    document.getElementById('gfg-search-results-mobile'),
    document.getElementById('gfg-mobile-search-form'),
    document.querySelector('.gfg-mobile-search__wrap')
  );

})();
